import { render, staticRenderFns } from "./Fila.vue?vue&type=template&id=65a89b8b"
import script from "./Fila.vue?vue&type=script&lang=js"
export * from "./Fila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports